import { format, parseISO } from "date-fns";

export const formatToLocaleDateString = (date: string) =>
  new Date(date).toLocaleDateString();

export const formatToMonthDayYear = (date: string) =>
  format(parseISO(date), "MMM d, yyyy");

export const formatDateToBE = (month: string, year: string) =>
  `${year}-${month.padStart(2, "0")}-01`;

export const formatDateFromBE = (dateString: string) => {
  const dateObject = dateString.split("-");
  const [year, month, day] = dateObject;
  return { year, month, day };
};

export const formatDateToMonthYear = (date: string) => {
  const formattedDate = parseISO(date);
  return format(formattedDate, "MMMM yyyy");
};

export const formatDateToComplete = (date: string) => {
  const formattedDate = parseISO(date);
  return format(formattedDate, "eee, MMM d, h:mm a");
};
